import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import AsyncSelect from "react-select/async";
import { AiOutlineCheck } from "react-icons/ai";
import { Modal, Typography, Button, Tag } from "components";

const VerifiedUnverifiedAgentsModal = ({
  showModal,
  verifiedUnverifiedAgentQuery,
  loadAgentsSuggestion,
  agentSearchStyles,
  handleModalClose,
  handleVerifiedUnverifiedAgentQueryChange,
}) => {
  const agentStatuses = [
    {
      label: "Verified",
      value: 0,
      color: "#27AE60",
      bgColor: "#EAFCF2",
    },
    {
      label: "Unverified",
      value: 1,
      color: "#AAA6A6",
      bgColor: "#F1F4F9",
    },
  ];
  const [selectedAgent, setSelectedAgent] = useState("");

  return (
    <Modal showModal={showModal} onClose={handleModalClose} customPadding={"0"}>
      <div className="report-filter-modal">
        <div className="header">
          <div className="d-flex justify-content-end ">
            <IoMdClose
              className="cursor-pointer"
              onClick={() => handleModalClose()}
            />
          </div>
          <Typography className={"text-center"}>
            Set Filter for Agent Report
          </Typography>
        </div>
        <Typography
          className={"text-center mt-4"}
          state="primary"
          variant="caption2"
        >
          Choose Agent
        </Typography>
        <div className="d-flex justify-content-center">
          <AsyncSelect
            cacheOptions
            loadOptions={loadAgentsSuggestion}
            styles={agentSearchStyles}
            value={selectedAgent}
            placeholder="Search with Agent Code, ID or Name"
            onChange={(value) => {
              setSelectedAgent(value || {});
              handleVerifiedUnverifiedAgentQueryChange({
                name: "agentId",
                value: value?.value,
              });
            }}
            isClearable
            loadingMessage={() => "Searching Agents..."}
          />
        </div>

        <Typography variant="body4" state="grey" className={"text-center mt-4"}>
          Select Agent Status
        </Typography>
        <div className="status-selection-container" style={{ width: "50%" }}>
          <div className="other-statuses justify-content-center">
            {agentStatuses.map((prop, key) => (
              <div
                className="tag-container"
                key={key}
                onClick={() =>
                  handleVerifiedUnverifiedAgentQueryChange({
                    name: "category",
                    value:
                      verifiedUnverifiedAgentQuery.category === prop.value
                        ? ""
                        : prop.value,
                  })
                }
              >
                {verifiedUnverifiedAgentQuery?.category === prop.value && (
                  <div className="check-icon">
                    <AiOutlineCheck
                      color={prop.color === "#FFFFFF" ? "#27AE60" : prop.color}
                    />
                  </div>
                )}

                <Tag
                  key={key}
                  {...{
                    textColor: prop.color,
                    backgroundColor: prop.bgColor,
                    text: prop.label,
                  }}
                  className="terminal-status-tag"
                  style={{
                    minWidth: "75px",
                    height: "28px",
                    cursor: "pointer",
                    fontSize: "4px",
                    margin: "0rem 1rem 1rem 0",
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="px-4 my-4">
          <Button
            label="Apply"
            size="xs"
            className={"mx-auto"}
            onClick={() => handleModalClose()}
          />
        </div>
      </div>
    </Modal>
  );
};

export default VerifiedUnverifiedAgentsModal;
